/**
 */
function ayuda() {
  window.open('https://docs.google.com/document/d/1GD_4EB1J4CUpr3I-htgVlZy4lxFZiwHS-bIquXIqtlk/edit', '_blank');
}

export default function () {
  const option = {
    name: 'Ayuda',
    action: ayuda,
    className: 'fa fa-question-circle',
    title: 'Ayuda',
  };

  return option;
}
